module.exports = {
      id: "icon-pause-usage",
      viewBox: "0 0 17.726 22.137",
      url: "/" + "sprite-906bd948b42f12135087bdf480fde2e1.svg#icon-pause",
      toString: function () {
        return this.url;
      }
    }